<template>
  <component :is="layout"></component>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useCommonData } from '@composables';
import { useCommonStore } from '@stores';
import ClearLayout from '@baseComponents/layout/ClearLayout.vue';
import DefaultLayout from '@baseComponents/layout/DefaultLayout.vue';
import { useSignIn } from '@composables';

const route = useRoute();
const commonStore = useCommonStore();

const layout = computed(() =>
  route?.meta?.layout === 'ClearLayout' ? ClearLayout : DefaultLayout
);
onMounted(async () => {
  console.log(commonStore.isSignIn);
  const { signInAuto } = useSignIn();
  if (localStorage.getItem('___refreshToken___') && !commonStore.isSignIn) {
    await signInAuto(String(localStorage.getItem('___refreshToken___')));
  }
});
useCommonData();
</script>

<style scoped lang="scss">
.index {
  @apply mt-1 font-sans;
}
h1 {
  @apply pd-[31] mg-[10] fs-[22];
}
</style>
